/**
 * ============================================================================
 * 平台判断
 * ============================================================================
 */
var sUserAgent = navigator.userAgent.toLowerCase();
export var UA = {
  Ie: !!document.all,
  Ie6: !!document.all && !window.XMLHttpRequest,
  Ie7: !!document.all && /msie 7.0/gi.test(window.navigator.appVersion),
  Ie8: !!document.all && /msie 8.0/gi.test(window.navigator.appVersion),
  FF: /firefox/gi.test(window.navigator.userAgent),
  Opera: /opera/gi.test(window.navigator.userAgent),
  Chrom: /Chrom/gi.test(window.navigator.userAgent),
  Maxthon: /Maxthon/gi.test(window.navigator.userAgent),
  android: /android|Adr/gi.test(sUserAgent),
  iphone: /iPhone|iPod|iPad/gi.test(sUserAgent),
  isWeiXin: sUserAgent.indexOf('micromessenger') > -1,
  isMobileQQ: sUserAgent.indexOf('sq') > -1 && sUserAgent.indexOf('yyb_d') > -1 || sUserAgent.indexOf('iphone os') > -1 && sUserAgent.indexOf('qq/') > -1,
  isQzone: sUserAgent.indexOf('qzone') > -1,
  isWeibo: sUserAgent.indexOf('weibo') > -1,
  isMQQBrowser: sUserAgent.indexOf('mqqbrowser') > -1,
  isFanxing: /fanxing2/.test(sUserAgent)
};
/**
 * ============================================================================
 * 繁星客户端通信接口
 * ============================================================================
 */

export function nativeCall(optionsObj) {
  //return false;
  var options = optionsObj;
  var sign = 'kz8F9YI0f7EMXyITzpgGFa3aT0wmwYR9Host2yFlPrUKE+DFY9jJDvXdVsQDOLa1YTOY7wnPTEN0PKyiWJsNDuM5ujSh5zvJvALS7sC3t/9mkHJinBN5yc9/pN0s2DyB2qz4W9rL5BUmfTqjcMb4jDbK+TJUZE/fEI9nKMILhs0=';

  if (UA.isFanxing) {
    if (options && options.sign) {
      sign = options.sign;
    } // var data = '{"cmd":"'+options.cmd+'","sign":"'+sign+'","jsonStr":'+JSON.stringify(options.data)+',"callback":"'+options.callbackName+'"}';


    var oData = {};
    oData.cmd = options.cmd;
    oData.sign = sign;
    oData.jsonStr = options.jsonStr;

    if (options.callbackName) {
      oData.callback = options.callbackName;
    }

    var data = JSON.stringify(oData);

    if (UA.iphone) {
      //lowDebug.log( 'fanxing2://' + (options.isBanner ? "fx.activity" : "send.message") + '/?' + data );
      location.href = 'fanxing2://' + (options.isBanner ? "fx.activity" : "send.message") + '/?' + data;
    } else if (window.external && window.external.callFanxing) {
      window.external.callFanxing(data); //window.external.callFanxing('{"cmd":"600","sign":"'+sign+'","jsonStr":{"pageType": 1001},"callback":""}');
    } else {//alert('网络有点不给力哦!重新进入页面再点击试试吧!');
      }
  }
}

window.getBase64 = function (imgUrl, callback) {
  var image = new Image();
  image.setAttribute('crossOrigin', 'anonymous');
  image.src = imgUrl;

  image.onload = function () {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    var dataURL = canvas.toDataURL();
    callback && callback(dataURL);
  };
}; //对象扩展


export var $extend = function $extend(destination, source) {
  if (typeof destination == "object") {
    if (typeof source == "object") {
      for (var i in source) {
        destination[i] = source[i];
      }
    }
  }

  if (typeof destination == "function") {
    if (typeof source == "object") {
      for (var i in source) {
        destination.prototype[i] = source[i];
      }
    }

    if (typeof source == "function") {
      destination.prototype = source.prototype;
    }
  }

  return destination;
};